import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import {compose} from "recompose";
import {sensorsTypes} from "./commons/sensorsTypes";
import AgIcon from "./commons/AgIcon";
import clsx from "clsx";
import {getColor, getColorDots} from "./utils/colors/colors";
import Dots from "./Dots";

const styles = theme => ({
    root: {
        padding: theme.spacing(),
        color: theme.palette.text.primary,
        textAlign: 'center'
    },
    container: {
        display: ({withDots}) => withDots ? 'block' : 'inline-block',
        padding: ({withDots}) => withDots ? [[6, 0]] : 0,
        textAlign: 'left',
        maxWidth: '20em',
        margin: 'auto'
    },
    firstLine: {
        display: 'flex',
        alignItems: 'baseline'
    },
    value: {
        ...theme.typography.h3,
        fontWeight: theme.typography.fontWeightLight,
        marginLeft: theme.spacing(),
    },
    indicator: {
        ...theme.typography.h6,
        marginLeft: theme.spacing(),
    },
    name: {
        ...theme.typography.button,
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightBold
    },
    dots: {
        marginTop: theme.spacing(),
    }
});

const SensorValue = ({
    className,
    classes,
    theme,
    sensorTypeName,
    value,
    withSensorTypeName,
    withDots,
    ...props
}) => {
    const sensorsType = sensorsTypes[sensorTypeName];
    if (!sensorsType) {
        throw Error(`Sensor key "${sensorTypeName}" is not valid`);
    }

    const dots = getColorDots(sensorTypeName, value);
    const color = getColor(sensorTypeName, dots);

    return <div className={clsx(classes.root, className)}>
        <div className={classes.container}>
            <div className={classes.firstLine}>
                <AgIcon icon={sensorsType.icon}/>
                <div
                    className={classes.value}
                    style={{
                        color: theme.palette[color].dark
                    }}
                >
                    {value}
                </div>
                <div className={classes.indicator}>{sensorsType.indicator}</div>
            </div>
            {withSensorTypeName && (
                <div className={classes.name}>{sensorsType.quasiExtendedName}</div>
            )}
            {withDots && (
                <Dots className={classes.dots} dots={dots} color={color}/>
            )}
        </div>
    </div>;
};

SensorValue.propTypes = {};

SensorValue.defaultProps = {
    withSensorTypeName: false,
    withDots: false,
};

export default compose(
    withStyles(styles, {withTheme: true})
)(SensorValue);
